import { Component, OnInit } from '@angular/core';
import * as fromRoot from '../../../../state/app.reducer';
import * as rootActions from '../../../../state/app.actions';
import * as fromCuttingTable from '../../../cutting_table/state/cutting_table.reducer';
import * as cutting_tableActions from '../../../cutting_table/state/cutting_table.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CuttingTable } from '../../../../_models/cutting_table';
import { CuttingTableType } from '../../../../_models/cutting_table_type';

@Component({
  templateUrl: './cutting_table-edit-shell.component.html'
})

export class CuttingTableEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    cuttingTable$: Observable<CuttingTable>;
    cuttingTableTypes$: Observable<CuttingTableType[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromCuttingTable.State>
  ) {}

  ngOnInit() {

    this.cuttingTable$ = this.store.pipe(select(fromCuttingTable.getCurrentCuttingTable)) as Observable<CuttingTable>;
    this.cuttingTableTypes$ = this.store.pipe(select(fromCuttingTable.getCuttingTableTypesList)) as Observable<CuttingTableType[]>;

  }

  saveCuttingTable(cutting_tableIn: CuttingTable): void {

    console.log('---> saveCuttingTable cutting_tableIn:');
    console.log(cutting_tableIn);

    if (cutting_tableIn.id === null) {
      console.log('Se va a CREAR una nueva obra.');
      this.store.dispatch( new cutting_tableActions.CreateCuttingTable(cutting_tableIn));
    } else {
      console.log('Se va a MODIFICAR una obra existente.');
      this.store.dispatch( new cutting_tableActions.UpdateCuttingTable(cutting_tableIn));
    }
  }

  editCuttingTable(e: Event) {
    console.log('-> -> Pulsado botón editCuttingTable. Evento: ');
    console.log(e);

  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class CuttingTableEditShellComponent
